import { useMutation } from '@tanstack/react-query'
import { SESSION_STORAGE } from '../../../constants/sessionStorage'
import { AxiosError } from 'axios'
import { ErrorHandling } from '../../../@types/ErrorHandling'
import {
    ResumePetisSimulationProposalClientRequest,
    ResumePetisSimulationProposalClientResponse,
} from '../../../@types/ResumePetisSimulationProposal'
import { api } from '../../../Services/API'
import { useResumePetisSimulationProposalStore } from '../../../Stores/useResumePetisSimulationProposalStore'
import { useAgent } from '../../../Stores/useAgent'
import { useResumeStore } from '../../../Stores/useResumeStore'
import { useFillDataForSimulation } from '../../../hooks/api/useFillDataForSimulation'
import { API_ROUTES } from '../../../constants/apiRoutes'
import { useInitialResume } from '../../hydration/useInitialResume'
import { useErrorRequest } from '../../useErrorRequest'

const request = async (payload: ResumePetisSimulationProposalClientRequest) => {
    const response = await api.post<ResumePetisSimulationProposalClientResponse>(
        API_ROUTES.useResumePetisSimulationProposal,
        payload,
    )

    return response.data
}

export const useResumePetisSimulationProposal = () => {
    const { handleErrorRequest } = useErrorRequest()
    const { handleInitialResume } = useInitialResume()
    const { setResumePetisSimulationProposal } =
        useResumePetisSimulationProposalStore()
    const { isResume } = useResumeStore()
    const { setAgentByResume } = useAgent()
    const {
        mutate: dataForSimulationMutate,
    } = useFillDataForSimulation()

    return useMutation({
        mutationFn: (payload: ResumePetisSimulationProposalClientRequest) =>
            request(payload!),
        onSuccess(data, variables) {
            setResumePetisSimulationProposal(data)
            if (!isResume) {
                let agentCode = data?.processData?.simulationData?.runPetisSimulationClientResponse?.runPetisSimulationResponse?.productData?.commercialNetwork?.find(c => c?.agentRole == "MED")?.agentCode;
                setAgentByResume(agentCode ?? "");
                dataForSimulationMutate(agentCode ?? "")
            }
            handleInitialResume({ data, variables })
        },
        onError(error: AxiosError<ErrorHandling[]>) {
            handleErrorRequest({ error })
        },
    })
}
